<div class="mac-option-container">
	<div class="clr-checkbox-wrapper">
		<input [ngModel]="selected" class="clr-checkbox" type="checkbox" />

		<label class="d-flex flex-column">
			<span *ngIf="label" class="mac-option-label">
				<svg-frontends-string-or-template-ref [value]="label" [class.disabled]="disabled"></svg-frontends-string-or-template-ref>
			</span>
			<span *ngIf="description" class="mac-footnote mac-option-description">
				<svg-frontends-string-or-template-ref [value]="description" [class.disabled]="disabled"></svg-frontends-string-or-template-ref>
			</span>
		</label>
	</div>
</div>
